import React from 'react'

import _ from 'lodash'
import moment from 'moment'

const BkFlowEditDateToggle = props => {
  const {
    initialDate,
    activeDateValue,
    dateField,
    fieldLabel,
    toggleDateEvent
  } = props

  return (
    <div className={_.isEmpty(initialDate) ?
      'bk-flow-edit-stay__date-toggle disabled u-flex u-flex--wrap u-flex--justify-center u-flex--align-center ' + dateField
    :
      'bk-flow-edit-stay__date-toggle u-flex u-flex--wrap u-flex--justify-center u-flex--align-center ' + dateField
    }
      onClick={() => toggleDateEvent(dateField)}
    >
      <p className="bk-flow-edit-stay__date-toggle-heading u-remove-margin u-font-bold u-font-small">{ fieldLabel }</p>
      <p className="bk-flow-edit-stay__date-toggle-weekday u-font-small">{ moment(activeDateValue).format('dddd') }</p>
      <p className="bk-flow-edit-stay__date-toggle-day h4">{ moment(activeDateValue).format('D') }</p>
      <p className="bk-flow-edit-stay__date-toggle-month u-font-small">{ moment(activeDateValue).format('MMM') }, { moment(activeDateValue).format('YYYY') }</p>
      <i className="bk-flow-edit-stay__date-toggle-arrow material-icons">arrow_drop_down</i>
    </div>
  )
}

export default BkFlowEditDateToggle



// WEBPACK FOOTER //
// ./src/components/edit/dates/layouts/BkFlowEditDateToggle.js